// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1W5TV","content":"ManualTimeModal_content__XAFhM"};